<template lang="pug">
  b-form-input(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    @blur.native="handleBlur"
    :formatter="format"
    :lazy-formatter="lazyFormatter"
    )
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    size: {
      type: String,
      default: "md"
    },
    lazyFormatter: {
      type: Boolean,
      default: false
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleBlur(e) {
      this.$emit("blur", e.srcElement.value);
    },
    handleInput(e) {
      this.$emit("input", e);
    },
    format(value, event) {
      // this.$emit("format", value, event);
      if(!this.fieldRequired)
        return value;

      if(event.target == null)
        return value;

      if(value == null || value == "")
        return 0;

      return value;
    }
  }
};
</script>
